import Model from './model'

export default class Hero extends Model {
  constructor() {
    super()
    this.hydrate({
      file: ''
    })
  }
}
